module.exports = __webpack_public_path__ + "static/media/Navigate Sample Content Search Results with Back, Forward and Home Controls.99080cd4.png";